import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { JsonApiResponse } from '@app/interfaces';
import { AssignableSlots } from '@app/modules/documents-v2/interfaces/assignable-slot.interface';
import { SigningTemplateSlot } from '@models/documents/signing-template-slot.model';
import { SigningTemplate } from '@models/documents/signing-template.model';
import { Employee } from '@models/employee/employee.model';

@Injectable({
    providedIn: 'root',
})
export class EmployeeTemplateCustomFieldsQueryService {
    constructor(private http: HttpClient) {}

    /**
     * Find custom field statuses for a set of employees on a template. Optional slot allows for constraining the custom fields
     * to a specific slot.
     */
    async query(
        template: SigningTemplate | null,
        employees: Employee[],
        slot: SigningTemplateSlot | null
    ): Promise<AssignableSlots> {
        if (!template || !employees.length) {
            return {};
        }
        const url = `/v2/signingTemplates/${template.id}/checkEmployees`;
        return this.http
            .post(url, {
                employees: employees.map((employee) => employee.id),
                slot: slot?.name,
            })
            .toPromise()
            .then(({ data }: JsonApiResponse<null>) => data as unknown as AssignableSlots);
    }
}
